import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'equals',
  standalone: false
})
export class EqualsPipe implements PipeTransform {
    transform(object1: any, object2: any) {
        return JSON.stringify(object1) == JSON.stringify(object2)
    }
}